import { render } from "./ClearableInput.vue?vue&type=template&id=2c1a1cb8&scoped=true&lang=pug"
import script from "./ClearableInput.vue?vue&type=script&lang=ts"
export * from "./ClearableInput.vue?vue&type=script&lang=ts"

import "./ClearableInput.vue?vue&type=style&index=0&id=2c1a1cb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c1a1cb8"

export default script